import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, CalendarDays, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return iso; }
}

export default function Lineups() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/games?league=NBA").then((r) => setGames(r.data.games || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="lineups-page" className="max-w-[900px] mx-auto px-4 sm:px-6 py-6">
      <h1 className="font-heading font-extrabold text-2xl sm:text-3xl text-slate-100 mb-1 flex items-center gap-2">
        <Users size={22} className="text-[#00E5A3]" /> NBA Lineups
        <Badge className="bg-[#00E5A3]/15 text-[#00E5A3] border-0 text-[10px] font-mono">~30 MIN PRE-TIP</Badge>
      </h1>
      <p className="text-sm text-slate-400 mb-5 max-w-2xl">
        Confirmed starting lineups and late scratches for every NBA game — the biggest last-minute swing in
        basketball. Open a game for its starters and any players ruled out. Lineups firm up ~30 minutes before tip-off.
      </p>
      {loading ? (
        <div className="text-center py-16 text-slate-500 text-sm">Loading NBA slate…</div>
      ) : games.length === 0 ? (
        <div data-testid="lineups-empty" className="text-center py-16 text-slate-500 text-sm">
          No NBA games scheduled right now. The board fills as the league posts each day's slate.
        </div>
      ) : (
        <div className="space-y-2">
          {games.map((g) => (
            <Link key={g.id} to={`/games/NBA/${g.id}`} data-testid={`lineup-game-${g.id}`}
              className="flex items-center justify-between gap-3 rounded-xl bg-[#0F1420] border border-[#232D42] p-3 hover:border-[#00E5A3]/40 transition-colors">
              <div className="flex items-center gap-2 min-w-0">
                {g.away?.logo && <img src={g.away.logo} alt="" className="h-6 w-6 object-contain" />}
                <span className="font-heading font-semibold text-slate-100 truncate">{g.away?.abbr}</span>
                <span className="text-slate-600 text-xs">@</span>
                {g.home?.logo && <img src={g.home.logo} alt="" className="h-6 w-6 object-contain" />}
                <span className="font-heading font-semibold text-slate-100 truncate">{g.home?.abbr}</span>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-[11px] font-mono text-slate-500 flex items-center gap-1"><CalendarDays size={11} /> {fmtDate(g.date)}</span>
                <ChevronRight size={16} className="text-[#00E5A3]" />
              </div>
            </Link>
          ))}
        </div>
      )}
      <p className="text-[11px] text-slate-600 mt-6">Source: ESPN. Research only — not betting advice.</p>
    </div>
  );
}
